// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".company-logo[data-v-26084dc2] {\n  max-height: 90px;\n}\n.center[data-v-26084dc2] {\n  margin: 0 auto;\n}\n.img-fluid[data-v-26084dc2] {\n  width: 100%;\n  height: auto;\n}\n.container2-form-login[data-v-26084dc2] {\n  width: 80%;\n}\n.links[data-v-26084dc2] {\n  -webkit-box-align: end;\n      -ms-flex-align: end;\n          align-items: flex-end;\n}\n", ""]);
// Exports
module.exports = exports;
